import { logger } from '../../utils/debug/logger.js';

export const EVENTS = {
    // Événements liés aux individus
    INDIVIDUAL: {
        ADDED: 'individual:added',
        SELECTED: 'individual:selected'
    },
    INDIVIDUALS: {
        BULK_ADDED: 'individuals:bulk_added'
    },

    // Événements liés à la configuration
    CONFIG: {
        REQUESTED: 'config:requested',
        PROVIDED: 'config:provided',
        UPDATED: 'config:updated'
    },

    // Événements liés au cache - STANDARDISÉS ✅
    CACHE: {
        BUILT: 'cache:built',              // { source, individualsCount, cacheSize, cacheSizeMB, isDirectImport, isRestoringFromCache, timestamp }
        CLEARED: 'cache:cleared',
        ERROR: 'cache:error',
        UPDATED: 'cache:updated',
        REQUESTED: 'cache:requested',
        PROVIDED: 'cache:provided',
        PROCESSED_READY: 'cache:processed_ready',
        STATUS: {
            REQUESTED: 'cache:status:requested',
            PROVIDED: 'cache:status:provided'
        }
    },

    // Événements liés à la hiérarchie et aux générations
    HIERARCHY: {
        CHANGED: 'hierarchy:changed',
        BUILT: 'hierarchy:built'
    },
    GENERATIONS: {
        UPDATED: 'generations:updated',
        MAX_CALCULATED: 'generations:max_calculated'
    },

    // Événements liés à la racine
    ROOT: {
        CHANGED: 'root:changed',
        UPDATED: 'root:updated'
    },

    // Événements liés aux visualisations
    VISUALIZATIONS: {
        FAN: {
            DRAWN: 'visualization:fan:drawn',
            UPDATED: 'visualization:fan:updated',
            PARAMETERS_CHANGED: 'visualization:fan:parameters:changed'
        },
        MAP: {
            DRAWN: 'visualization:map:drawn',
            UPDATED: 'visualization:map:updated',
            API_READY: 'visualization:map:api:ready',
            API_ERROR: 'visualization:map:api:error',
            LAYERS: {
                CHANGED: 'visualization:map:layers:changed',
            },
            SURNAME_CHANGED: 'visualization.map.surname.changed'
        }
    },

    // Événements liés à l'interface utilisateur
    UI: {
        TABS: {
            CHANGED: 'ui:tabs:changed',
            SHOWN: 'ui:tabs:shown',
            HIDDEN: 'ui:tabs:hidden',
            TIMELINE_SHOWN: 'ui:tabs:timeline:shown'
        },
        PANELS: {
            SHOWN: 'ui:panels:shown',
            HIDDEN: 'ui:panels:hidden'
        }
    },

    // Événements liés à l'onboarding
    ONBOARDING: {
        APP_LOADED: 'onboarding:app_loaded',
        GEDCOM_UPLOADED: 'onboarding:gedcom_uploaded',
        VISUALIZATION_READY: 'onboarding:visualization:ready',
        TOUR_STARTED: 'onboarding:tour:started',
        TOUR_COMPLETED: 'onboarding:tour:completed',
        TOUR_CANCELLED: 'onboarding:tour:cancelled'
    },

    // Événements liés au traitement des données - STANDARDISÉS ✅
    PROCESS: {
        START: 'process:start',        // { step, message, timestamp, processId }
        COMPLETE: 'process:complete',  // { step, message, duration, timestamp, processId, individualsCount }
        ERROR: 'process:error'         // { step, error, duration, timestamp, processId, stack }
    },

    // Événements liés à l'IA d'extraction de notes - NOUVEAU ✅
    AI_NOTES: {
        PROCESSING_STARTED: 'ai_notes:processing_started',     // { totalNotes }
        PROCESSING_PROGRESS: 'ai_notes:processing_progress',   // { processed, total, percentage }
        PROCESSING_COMPLETED: 'ai_notes:processing_completed', // { total_events_extracted, success_rate, processingTime }
        PROCESSING_FAILED: 'ai_notes:processing_failed',       // { error }
        EXTRACTION_COMPLETED: 'ai_notes:extraction_completed', // { personId, eventsCount, processingTime }
        EXTRACTION_FAILED: 'ai_notes:extraction_failed'        // { personId, error }
    },

    // Événements liés à l'enrichissement depuis sources externes (Wikipedia, Media)
    ENRICHMENT: {
        SEARCH_STARTED: 'enrichment:search_started',         // { individualId, source }
        SEARCH_COMPLETED: 'enrichment:search_completed',     // { individualId, resultsCount }
        EXTRACTION_STARTED: 'enrichment:extraction_started', // { individualId, source, articleTitle }
        EXTRACTION_COMPLETED: 'enrichment:extraction_completed', // { individualId, eventsCount }
        EXTRACTION_FAILED: 'enrichment:extraction_failed',   // { individualId, error }
        EVENTS_INTEGRATED: 'enrichment:events_integrated'    // { individualId, addedCount, source }
    },

    // Mutations de l'arbre en mémoire hors pipeline d'import (éditions
    // manuelles d'événements, suppressions). Déclenche l'auto-save du
    // .geneatree via treeAutoSaveService.
    TREE: {
        MODIFIED: 'tree:modified'                             // { source: 'edit' | 'delete' | ... }
    },

    // Événements liés au chargement des événements historiques
    HISTORICAL_EVENTS: {
        LOAD_START: 'historical_events:load:start',
        LOAD_COMPLETE: 'historical_events:load:complete',   // { count, source }
        LOAD_ERROR: 'historical_events:load:error'           // { error }
    },

    // Événements liés aux fichiers GEDCOM - STANDARDISÉS ✅
    GEDCOM: {
        IMPORT_STARTED: 'gedcom:import:started',    // { type, source, filename, size, timestamp }
        IMPORT_COMPLETE: 'gedcom:import:complete',
        IMPORT_ERROR: 'gedcom:import:error'
    },

    // Identité du fichier files-service couramment chargé. Émis quand
    // setCurrentFileId() est appelé (upload réussi, click sur dropdown,
    // ou clear). Le payload est { fileId: string|null }. tabStateStore
    // écoute ce signal pour verrouiller l'onglet Photos tant qu'aucun
    // GEDCOM persisté dans files-service n'est actif.
    FILE: {
        CURRENT_CHANGED: 'file:current:changed'    // { fileId }
    },

    // Événements liés aux imports avec métadonnées - STANDARDISÉS ✅
    IMPORT: {
        STARTED: 'import:started'  // { type: 'direct'|'upload'|'cache_restore', reason: string }
    },

    // Événements liés à l'état global
    STORE: {
        READY: 'store:ready',
        ERROR: 'store:error'
    },

    // Ces événements vont être dépréciés en faveur de VISUALIZATIONS.MAP.TOWNS
    TOWN: {
        UPDATE_START: 'visualization:map:towns:update:start',
        UPDATE_COMPLETE: 'visualization:map:towns:update:complete',
        UPDATE_ERROR: 'visualization:map:towns:update:error',
        UPDATED: 'visualization:map:towns:updated'
    }
};

class StoreEventEmitter {
    constructor() {
        this.listeners = new Map();
        this.debug = false; // Ajout d'un flag pour le debug
    }

    // Active/désactive le mode debug
    setDebug(enabled) {
        this.debug = enabled;
    }

    subscribe(event, listener) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(listener);

        if (this.debug) {
            logger.events.debug(`Event subscribed: ${event}`);
        }

        // Return disposer function
        return () => {
            const eventListeners = this.listeners.get(event);
            if (eventListeners) {
                eventListeners.delete(listener);
                if (eventListeners.size === 0) {
                    this.listeners.delete(event);
                }
                if (this.debug) {
                    logger.events.debug(`Event unsubscribed: ${event}`);
                }
            }
        };
    }

    emit(event, data) {
        // Toujours logger l'émission de l'événement fan:drawn pour le débogage
        if (event === 'visualization:fan:drawn') {
            logger.events.info(`⚡ Event ${event} émis à ${new Date().toISOString()}`);
        } else if (this.debug) {
            logger.events.debug(`Event emitted: ${event}`, data);
        }

        // Si c'est l'événement fan chart drawn, vérifier qu'il y a des écouteurs
        if (event === 'visualization:fan:drawn') {
            const listenerCount = this.listeners.has(event) ? this.listeners.get(event).size : 0;
            logger.events.info(`Nombre d'écouteurs pour ${event}: ${listenerCount}`);
        }

        if (this.listeners.has(event)) {
            this.listeners.get(event).forEach(callback => {
                try {
                    callback(data);
                } catch (error) {
                    logger.events.error(`Error in event listener for ${event}:`, error);
                }
            });
        }
    }

    // Méthode utilitaire pour lister tous les événements actifs
    listActiveEvents() {
        return Array.from(this.listeners.keys());
    }

    // Méthode utilitaire pour compter les écouteurs par événement
    countListeners(event) {
        return this.listeners.has(event) ? this.listeners.get(event).size : 0;
    }
}

export const storeEvents = new StoreEventEmitter();